import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useAuth } from "../data/AuthHook";
import "./Nav.css";

function Footer() {
  const { version } = useAuth();

  return (
    <Container className="coreContent nav-content">
      <Row>
        <Col className="mt-5 text-black-50" xs={2}>
          <small>{version}</small>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
